export const signPageTranslations = {
	heading: {
		sv: "Granska & Signera",
	},
	subHeading: {
		sv: "Här kan du se vilka produkter som ingår i ditt paket. Du kan också signera ditt avtal.",
	},
	subHeading2: {
		sv: "Om ni är flera som behöver godkänna beställningen ser du vilka som kan signera och när de skrivit under.",
	},
	companyInfo: {
		heading: {
			sv: "Företagets Information",
		},
	},
	completedSigning: {
		sv: "Nu har alla signerat avtalen. Du kan fortsätta med din ansökan.",
	},
	signWithBankId: {
		sv: "Signera med BankID",
	},
	bankIdHelp: {
		sv: "Starta BankID-appen på din telefon.\nTryck på QR-symbolen.\nRikta kameran mot QR-koden.",
	},
	agreementCheckboxText: {
		sv: "Jag har läst och godkänt det här avtalet",
	},
	openBankIdApp: {
		sv: "BankID på denna enhet",
	},
	signingInProgress: {
		sv: "Starta BankID-appen på din mobil eller surfplatta för att skriva under.",
	},
	agreementSuccessModal: {
		title: {
			sv: "Ditt avtal är signerat",
		},
		descriptionGuarantor: {
			sv: "Du har signerat avtalet för personlig borgen.",
		},
		descriptionPackage: {
			sv: "Finns det fler firmatecknare som måste signera behöver det vara klart innan din ansökan kan behandlas.",
		},
	},
	package: {
		signAgreementButton: {
			sv: "Signera avtal",
		},
		products: {
			title: {
				sv: "Produkter",
			},
			subTitle: {
				sv: "Tilläggsprodukter",
			},
		},
		descriptionPrimary: {
			sv: `I många företag behöver mer än en person signera avtalen. Nedan har vi listat alla
        potentiella avtalstecknare i ditt företag. Lägg till mejladressen till de som ska signera de
        får då en direktlänk där de kan granska och skriva under avtalet. Om du inte har deras
        mejladress kan du istället be dem att logga in på `,
		},
		descriptionBold: {
			sv: "bliforetagskund.svea.com/login",
		},
		descriptionSecondary: {
			sv: " och skriva under med BankID",
		},
		singleSigner: {
			sv: "Om du tecknar firman själv kan du signera avtalet här nedan och fortsätta i flödet.",
		},
		signInstructionSubtitle: {
			sv: "Enligt bolagsverket signeras kundavtalet på det här sättet:",
		},
		guarantorSigningTitle: {
			sv: "Personlig Borgen",
		},
		packageSigningTitle: {
			sv: "Kundavtal",
		},
		needMorePackageSignaturesWarning: {
			sv: "Vi behöver fler signaturer på kundavtalet innan ni kan signera avtalet för personlig borgen.",
		},
		needMoreGuarantorSignaturesWarning: {
			sv: "Vi behöver ha fler signaturer på borgensavtalet innan ansökan kan skickas in.",
		},
		signed: {
			sv: "Signerat",
		},
		signedDone: {
			sv: "Signering klar",
		},
		notSigned: {
			sv: "Ej signerat",
		},
		notEligible: {
			sv: "Personen kan inte agera borgenär",
		},
	},
	assignEmailModal: {
		titlePackage: {
			sv: "Maila avtal till signatorer",
		},
		titleGuarantor: {
			sv: "Maila avtal till borgensmän",
		},
		descriptionPackage: {
			sv: "För att skicka avtalet till de som behöver signera behöver du ange deras mejladresser. Skriv in mejladresser till alla på listan. Tänk på att det kan ta upp till ett dygn innan du får en bekräftelse skickad till din mejl.",
		},
		descriptionGuarantor: {
			sv: "För att skicka avtalet till de som ska signera behöver du ange deras mejladresser. Tänk på att du måste skriva in mejladresser till alla personer som finns på listan. Mejlet skickas när du signerat avtalet i nästa steg.",
		},
		emailPlaceHolder: {
			sv: "Mejl",
		},
		cancelButton: {
			sv: "Avbryt",
		},
		sendButton: {
			sv: "Skicka avtal",
		},
	},

	signing: {
		guarantorSign: {
			title: {
				sv: "Signera borgen",
			},
			description: {
				sv: "Här kan du signera borgen. Om det är fler personer som behöver signera kan du lägga till deras mejladress, De får då en direktlänk där de kan granska och skriva under. Om du inte har deras mejladress kan du istället be dem att logga in på bliforetagskund.svea.com/login och skriva under med BankID.",
			},
			descriptionBold: {
				sv: "Du behöver välja minst en borgensman vid val av kreditprodukter.",
			},
		},
		agreementSigning: {
			title: {
				sv: "Signera kundavtal",
			},
		},
		confirmSigningModal: {
			titleGuarantor: {
				sv: "Ditt avtal är signerat",
			},
			titlePackage: {
				sv: "Ditt kundavtal är signerat",
			},
		},
	},
	guarantors: {
		title: {
			sv: "Välj borgensman",
		},
		description: {
			sv: `Eftersom du valt kreditprodukter behöver vi en garanti om personlig borgen. Välj den eller de
      personer som går i borgen för ditt företag. Vi gör alltid en bakgrundskoll och
      kreditupplysning för de personer som går i personlig borgen. `,
		},
		changeButton: {
			sv: "Ändra",
		},
		noGuarantorChosenError: {
			sv: "Välj en personlig borgen",
		},
	},
	resetGuarantorFlowModal: {
		title: {
			sv: "Vill du ändra borgensman?",
		},
		description: {
			sv: "Om du ändrar borgensman kommer informationen du angett i det här steget att försvinna och du behöver gå igenom stegen på nytt. Avtalen kommer att behöva signeras igen. ",
		},
		acceptButton: {
			sv: "Ändra borgensman",
		},
	},
	reviewPage: {
		title: {
			sv: "Granska beställning",
		},
		subHeading: {
			sv: "Här kan du se vilka produkter som ingår i det paket som du valt. ",
		},
		total: {
			sv: "Summa",
		},
		companyPackageTitle: {
			sv: "Företagspaket {0}",
		},
		memberPackageTitle: {
			sv: "Medlemspaket {0}",
		},
	},
	addGuarantorModal: {
		title: {
			sv: "Lägg till en borgensman",
		},
		description1: {
			sv: "Fyll i personnummer till den som ska gå i personlig borgen. De kommer själva behöva logga in och signera avtalet.",
		},
		description2: {
			sv: "Vill du lägga till den här personen som borgensman?",
		},
		closeButton: {
			sv: "Avbryt",
		},
		addButton: {
			sv: "Lägg till",
		},
		chooseButton: {
			sv: "Välj",
		},
		getNameButton: {
			sv: "Hämta namn",
		},
		ssnLabel: {
			sv: "Personnummer",
		},
		addAnotherPerson: {
			sv: "Lägg till en annan person",
		},
	},
};
